import { FC, useEffect, useState } from 'react'

import { useNavigate } from '@tanstack/react-router'
import { ADVERSE_MEDIA_PATH } from 'commons/constants/routes'
import { AdverseMedia } from 'commons/types/DTO/bank/companyDetails/adverseMedia'
import { TableDataQa } from 'commons/types/enums'
import { Layer, Table } from 'ui/components'
import { PageSectionPrimary } from 'ui/components/Page'

import { handlerServerError } from '@orbit/errors'

import { CompanyAdverseMediaCaseTableProps } from './CompanyAdverseMediaCaseTableProps'
import { columns } from './columns'
import { useComponentsEssence } from './hooks/useComponentsEssence'
import { useFilterCompanyAdverseMediaWebPage } from './hooks/useFilterCompanyAdverseMediaWebPage'

export const CompanyAdverseMediaCaseTable: FC<CompanyAdverseMediaCaseTableProps> = (props) => {
  const {
    data: { id, showAdverseMedia, showAdverseMediaTotalCount }
  } = props
  const navigate = useNavigate()

  const [webPageData, setWebPageData] = useState({
    adverseMedia: showAdverseMedia,
    adverseMediaTotalCount: showAdverseMediaTotalCount
  })

  useEffect(() => {
    setWebPageData({
      adverseMedia: showAdverseMedia,
      adverseMediaTotalCount: showAdverseMediaTotalCount
    })
  }, [showAdverseMedia, showAdverseMediaTotalCount])

  const { routine: filterCompanyAdverseMediaWebPage } = useFilterCompanyAdverseMediaWebPage({
    onSuccess: async (_, result) => {
      await setWebPageData(result)
    },
    onError: (error) => handlerServerError(error)
  })
  const { loading, tableState, changePagination } = useComponentsEssence(id, filterCompanyAdverseMediaWebPage)

  return (
    <PageSectionPrimary face="outlined" title="Adverse Media" anchor="adverse">
      <Layer rounded shadowed stretch>
        <Table<AdverseMedia>
          dataQa={TableDataQa.BP_COMPANY_ADVERSE_MEDIA_CASE}
          columns={columns({ rootUrl: ADVERSE_MEDIA_PATH }, navigate)()}
          dataSource={webPageData?.adverseMedia?.map((el) => ({
            item: el
          }))}
          loading={loading}
          pagination={{
            page: tableState.page,
            size: tableState.size,
            onChange: changePagination,
            total: webPageData.adverseMediaTotalCount
          }}
        />
      </Layer>
    </PageSectionPrimary>
  )
}
